export enum KustomTrackEvents {
  FINALIZE_CLICKED = "finalize clicked",
  QUIT_CLICKED = "quit clicked",
}
